
export const IMAGE_URL = 'https://dirapi.atldmo.ir/';
export const API_URL = IMAGE_URL + 'api/v1/';

export const MAP_API_KEY = 'AIzaSyBk1Y3RjIlfRt5IyiK_SXuRwuGSQHgSsus ';



// WEBPACK FOOTER //
// ./src/config/Config.js